
    import './styles.scoped.css';
    export default {
  "alert": "awsui_alert_mx3cw_6fw2d_3",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_mx3cw_6fw2d_1",
  "root": "awsui_root_mx3cw_6fw2d_25",
  "hidden": "awsui_hidden_mx3cw_6fw2d_38",
  "body": "awsui_body_mx3cw_6fw2d_60",
  "header": "awsui_header_mx3cw_6fw2d_66",
  "action": "awsui_action_mx3cw_6fw2d_70",
  "action-button": "awsui_action-button_mx3cw_6fw2d_75",
  "text": "awsui_text_mx3cw_6fw2d_79",
  "icon": "awsui_icon_mx3cw_6fw2d_83",
  "message": "awsui_message_mx3cw_6fw2d_86",
  "breakpoint-default": "awsui_breakpoint-default_mx3cw_6fw2d_94",
  "content": "awsui_content_mx3cw_6fw2d_108",
  "dismiss": "awsui_dismiss_mx3cw_6fw2d_112",
  "dismiss-button": "awsui_dismiss-button_mx3cw_6fw2d_118",
  "type-error": "awsui_type-error_mx3cw_6fw2d_126",
  "type-warning": "awsui_type-warning_mx3cw_6fw2d_134",
  "type-success": "awsui_type-success_mx3cw_6fw2d_142",
  "type-info": "awsui_type-info_mx3cw_6fw2d_150"
};
  